import linepackBalanced from './templates/linepackBalanced';
import spreadByHour from './templates/spreadByHour';
import tradeVSDelivery from './templates/tradeVSDelivery';

export const guideTemplates = [
    {
        id: 'ttf-balanced',
        title: 'TTF is balanced @ Hour 12',
        description: 'Check if the TTF market is balanced at noon.',
        nodeStructure: linepackBalanced.data
    },
    {
        id: 'spread-hour',
        title: 'Spread by Hour',
        description: 'Analyze how the spread changes throughout the day.',
        nodeStructure: spreadByHour.data
    },
    {
        id: 'trade-vs-delivery',
        title: 'Trade vs Delivery',
        description: 'Compare traded prices against delivery outcomes.',
        nodeStructure: tradeVSDelivery.data
    }
];
